/**
 * <Card> — the post-ejo4 card recipe, codified.
 *
 * Notebook look: card-white surface, 1.5px ink border, 18px radius.
 * Variants:
 *   static       — plain panel. Informational, not clickable. No hover, no
 *                  cursor change.
 *   interactive  — static plus cursor-pointer and a 4px offset ink shadow on
 *                  hover. Add focus-ring at the call site via the `as="button"`
 *                  prop for keyboard a11y.
 *   selected     — soft-marigold fill, locked in (use with isSelected).
 *   lifted       — static with a permanent 4px offset ink shadow. Hero panels.
 *
 * Sizing/padding is the caller's job — Card only owns the surface treatment.
 *
 *   <Card variant="interactive" onClick={...} className="p-4">
 *     ...
 *   </Card>
 */
import React, { forwardRef } from 'react';

const VARIANTS = {
  static: 'bg-card border-1.5 border-ink rounded-[18px]',
  interactive:
    'bg-card border-1.5 border-ink rounded-[18px] cursor-pointer ' +
    'hover:shadow-nb transition-shadow',
  selected:
    'bg-hl-soft border-1.5 border-ink rounded-[18px] cursor-pointer',
  lifted: 'bg-card border-1.5 border-ink rounded-[18px] shadow-nb',
};

function cn(...parts) {
  return parts.filter(Boolean).join(' ');
}

const Card = forwardRef(function Card(
  { variant = 'static', as: As = 'div', className = '', children, ...rest },
  ref
) {
  return (
    <As ref={ref} className={cn(VARIANTS[variant], className)} {...rest}>
      {children}
    </As>
  );
});

export default Card;
